import React from "react";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  
const EmailTemplateTabs =({ selectedTab, onSelectTab })=> {
  const tabs = [
    { name: 'Create Template', current: selectedTab === 'Create Template' },
    { name: 'Preview Template', current: selectedTab === 'Preview Template' },
  ];
    return (
      <div>
        <div className="block">
          <nav className="grid grid-cols-2" aria-label="Tabs">
            {tabs.map((tab, tabIdx) => (
              <button
                key={tab.name}
                onClick={() => onSelectTab(tab.name)}
                className={classNames(
                  tab.current ? 'bg-customGray text-white' : ' bg-[#EBEFF3] text-[#485868]',
                  tabIdx === 0 ? 'rounded-l-lg' : '',
                  tabIdx === tabs.length - 1 ? 'rounded-r-lg' : '',
                  'group overflow-hidden h-[42px] flex items-center justify-center text-center text-sm font-bold leading-[160%]'
                )}
                aria-current={tab.current ? 'page' : undefined}
              >
                <span>{tab.name}</span>
              </button>
            ))}
          </nav>
        </div>
      </div>
    )
  }
  export default EmailTemplateTabs;
  